import { yupResolver } from '@hookform/resolvers/yup';
import { object, string } from 'yup';

import {
  DictionaryCustomFieldType,
  ICustomDictionaryItem,
  ICustomDictionaryType,
  IDictionaryTypeCustomField,
} from '~/services/api/dictionaries/types';
import { fieldIsRequired, fieldMaxLength } from '~/ui/constants/errorMessages';

export interface IDictionaryFormValues {
  value: string;
  [field: string]: string | number | boolean;
}

const getNameSchema = ({ name, hasDesignedModal, nameMaxLength }: ICustomDictionaryType) => {
  const schema = string().trim();
  const requiredSchema = hasDesignedModal ? schema.required(fieldIsRequired(name)) : schema;

  return nameMaxLength
    ? requiredSchema.max(nameMaxLength, fieldMaxLength(nameMaxLength, name))
    : requiredSchema;
};

const getTextFieldsSchema = (textFields: IDictionaryTypeCustomField[]) =>
  Object.fromEntries(
    textFields.flatMap(({ name, title, maxLength }) =>
      maxLength
        ? [[name, string().nullable().max(maxLength, fieldMaxLength(maxLength, title))]]
        : [],
    ),
  );

export const getValidationResolver = (
  dictionaryType: ICustomDictionaryType,
  textFields: IDictionaryTypeCustomField[],
) =>
  yupResolver(
    object().shape({
      value: getNameSchema(dictionaryType),
      ...getTextFieldsSchema(textFields),
    }),
  );

export const getDefaultValues = (
  dictionaryItem: ICustomDictionaryItem,
  customFields: IDictionaryTypeCustomField[],
): IDictionaryFormValues => ({
  value: dictionaryItem.value ?? '',
  ...Object.fromEntries(
    customFields.map(({ name, type }) => [
      name,
      type === DictionaryCustomFieldType.CHECKBOX
        ? Boolean(dictionaryItem[name])
        : (dictionaryItem[name] as string | number) ?? '',
    ]),
  ),
});
